import { Box, Divider, Drawer, IconButton, SvgIcon } from '@mui/material';
import type { ReactNode } from 'react';
import { Typography } from './Typography';

export interface SideDrawerProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  width?: string | number | { xs: string | number; sm: string | number };
}

export const SideDrawer = ({
  open,
  title,
  onClose,
  children,
  footer,
  width = { xs: '100%', sm: '540px' },
}: SideDrawerProps) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        width,
        display: 'flex',
        flexDirection: 'column',
      },
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 2,
        flexShrink: 0,
      }}
    >
      <Typography
        variant="h6"
        noWrap
        sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', flex: 1, mr: 2 }}
      >
        {title}
      </Typography>
      <IconButton aria-label="close drawer" onClick={onClose}>
        <SvgIcon viewBox="0 0 24 24">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
        </SvgIcon>
      </IconButton>
    </Box>
    <Divider />

    <Box sx={{ flex: 1, px: 3, pt: 3, overflowY: 'auto' }}>
      {children}
    </Box>

    {footer && (
      <Box sx={{ px: 3, pb: 3, pt: 2, flexShrink: 0 }}>
        {footer}
      </Box>
    )}
  </Drawer>
);
